import React from "react";

import { useIntl } from "react-intl";
import { SegmentedControl } from "../../../../components/SegmentedControl";
import { Box } from "arkh";

export const TaskCheckResponseOptions = (props: {
  setType: (type: "check" | "posneg") => void;
  type: "check" | "posneg";
}) => {
  const intl = useIntl();
  return (
    <Box spaceBottom="medium" spaceHorizontal="medium">
      <SegmentedControl
        appearance="light"
        values={[
          intl.formatMessage({
            defaultMessage: "Check",
            description: "Task Check Response Type check",
          }),
          intl.formatMessage({
            defaultMessage: "Positive and negative",
            description: "Task Check Response Type positive and negative",
          }),
        ]}
        onChange={(event) =>
          props.setType(
            event.nativeEvent.selectedSegmentIndex === 0 ? "check" : "posneg"
          )
        }
        selectedIndex={props.type === "check" ? 0 : 1}
      />
    </Box>
  );
};
